import {IExtensionPoints, IPlugin, IPluginConfig} from "@athena-portal/core";
import {HelloPage} from "../pages/HelloPage";
import {ProductSelectionPage} from "../pages/ProductSelectionPage";
import {FalconPropositionEngineImpl, IFalconPropositionEngine, Types} from "@falcon/services";
import {WelcomePage} from "../pages/WelcomePage";
import {RetrievalDetailsPage} from "../pages/quote/RetrievalDetailsPage";
import {RetrieveQuotePage} from "../pages/quote/RetrieveQuotePage";
import {RetrieveQuoteAndProceedPage} from "../pages/quote/RetrieveQuoteAndProceedPage";
import {QuoteLimit} from "../pages/quote/QuoteCloneLimitPage";
import {AggregatorErrorPage} from "../pages/AggregatorErrorPage";
import {EventWarningPage} from "../pages/EventWarningPage";
import {LoginPage} from "../pages/LoginPage";
import {RegisterPage} from "../pages/RegisterPage";
import {ComplaintsPage} from "../pages/ComplaintsPage";
import {PersonalDataRightsPage} from "../pages/PersonalDataRightsPage";
import {ContactUsPage} from "../pages/ContactUsPage";

const plugin: IPlugin<IPluginConfig> = {
    getName(): string {
        return "customerPortal";
    },

    register(extensions: IExtensionPoints, configuration: IPluginConfig): void {
        // Routes
        extensions.routes.add({
            path: "/",
            component: HelloPage,
            exact: true,
        });

        extensions.routes.add({
            path: "/products",
            component: ProductSelectionPage,
            exact: true,
        });

        extensions.routes.add({
            path: "/welcome",
            component: WelcomePage,
            exact: true
        });

        extensions.routes.add({
            path: "/retrieveQuote",
            component: RetrievalDetailsPage,
            exact: true
        });

        extensions.routes.add({
            path: "/retrieveQuote/products/:product/process/:process/interaction/:interactionId/language/:languageCode/email/:email/dob/:dateOfBirth",
            component: RetrieveQuotePage,
            exact: true
        });

        extensions.routes.add({
            path: "/retrieveQuote/:token",
            component: RetrieveQuoteAndProceedPage,
            exact: true
        });

        extensions.routes.add({
            path: "/quoteLimit",
            component: QuoteLimit,
            exact: true
        });

        extensions.routes.add({
            path: "/aggregatorError/:aggregator",
            component: AggregatorErrorPage,
            exact: true
        });

        extensions.routes.add({
            path: "/eventWarningPage",
            component: EventWarningPage,
            exact: true
        });

        extensions.routes.add({
            path: "/login",
            component: LoginPage,
            exact: true,
        });

        extensions.routes.add({
            path: "/register",
            component: RegisterPage,
            exact: true,
        });

        extensions.routes.add({
            path: "/complaints",
            component: ComplaintsPage,
            exact: true
        });

        extensions.routes.add({
            path: "/dataRights",
            component: PersonalDataRightsPage,
            exact: true
        });

        extensions.routes.add({
            path: "/contact",
            component: ContactUsPage,
            exact: true
        });

        // Services
        extensions.services.bind<IFalconPropositionEngine>(Types.FalconPropositionEngine).to(FalconPropositionEngineImpl);
    }
};

export default plugin;



// WEBPACK FOOTER //
// ./src/config/customerPortalPlugin.ts